import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 59.519 59.519',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2" transform="translate(-8 -8)">
        <path
          fill={fill}
          d="M37.759,8A29.759,29.759,0,1,0,67.519,37.759,29.76,29.76,0,0,0,37.759,8Zm0,50.639a5.52,5.52,0,1,1,5.52-5.52,5.52,5.52,0,0,1-5.52,5.52Zm4.8-15.759v.16a1.44,1.44,0,0,1-1.44,1.44H34.4a1.44,1.44,0,0,1-1.44-1.44v-.48c0-4.927,3.736-6.9,6.558-8.479,2.42-1.357,3.9-2.28,3.9-4.08,0-2.378-3.032-3.96-5.484-3.96-3.263,0-4.733,1.577-6.876,4.295a1.44,1.44,0,0,1-2,.256L24.9,27.44a1.44,1.44,0,0,1-.325-1.951c3.275-4.889,7.446-7.649,13.986-7.649,6.761,0,13.983,5.28,13.983,12.24C52.542,39.319,42.559,39.464,42.559,42.88Z"
          opacity="0.5"
        />
        <path
          fill={fill}
          d="M157.507,119.759a5.52,5.52,0,1,0,5.52,5.52A5.52,5.52,0,0,0,157.507,119.759Zm.8-29.759c-6.54,0-10.711,2.76-13.986,7.651a1.44,1.44,0,0,0,.325,1.949l4.164,3.157a1.44,1.44,0,0,0,2-.256c2.143-2.718,3.613-4.295,6.876-4.295,2.452,0,5.484,1.577,5.484,3.96,0,1.8-1.484,2.719-3.9,4.08-2.822,1.577-6.558,3.546-6.558,8.473v.48a1.44,1.44,0,0,0,1.44,1.44h6.72a1.44,1.44,0,0,0,1.44-1.44v-.16c0-3.415,9.983-3.56,9.983-12.8C172.289,95.28,165.066,90,158.306,90Z"
          transform="translate(-119.747 -72.16)"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
